import type { Me } from "../api/types";

export function hasRole(me: Me | null, ...roles: string[]): boolean {
  if (!me) return false;
  if (me.roles.includes("admin")) return true;
  return roles.some((r) => me.roles.includes(r));
}

export function primaryRole(me: Me | null): string {
  if (!me) return "";
  const order = ["admin", "manager", "finance", "buyer", "planner"];
  return order.find((r) => me.roles.includes(r)) ?? me.roles[0] ?? "";
}
